import type { MailboxInfo } from "owa-client-types";
import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { isEnabledForFrontierCopilotAudience, type FrontierFlightConfig, } from "./isEnabledForFrontierCopilotAudience";

const contextAnnotationsFrontierFlights: FrontierFlightConfig = {
    publicFlight: "time-copilot-bizchat-context-annotations-frontier-public",
    privateTapFlight: "time-copilot-bizchat-context-annotations-frontier-private-tap",
    privateStagingFlight: "time-copilot-bizchat-context-annotations-frontier-private-staging",
    privateInfluencerFlight: "time-copilot-bizchat-context-annotations-frontier-private-influencer",
};

/**
 * Single check for whether Copilot Bizchat context annotations are enabled.
 * Returns true if EITHER:
 * - The global `time-copilot-bizchat-context-annotations` flight is on (conventional rollout), OR
 * - The user is a licensed frontier user and the frontier flight for their type is enabled
 */
export function isBizchatContextAnnotationsEnabled(mailboxInfo: MailboxInfo = getGlobalSettingsAccountMailboxInfo()): boolean {
    return (isGlobalFeatureEnabled("time-copilot-bizchat-context-annotations") ||
        isEnabledForFrontierCopilotAudience(mailboxInfo, contextAnnotationsFrontierFlights));
}
